import { createContext, useContext } from "react";

export interface PermissionState {
  /** Whether the current user is restricted to read-only (viewer role) */
  isReadOnly: boolean;
  /** Raw permission keys from the roles API */
  permissions: string[];
  /** Primary role string (e.g., "ROLE_SAV_ISPMADMIN") */
  userRole: string;
  /** Raw license/tenant data */
  license: Record<string, unknown> | undefined;
}

const defaultState: PermissionState = {
  isReadOnly: true, // deny by default until roles resolve
  permissions: [],
  userRole: "",
  license: undefined,
};

export const PermissionStateContext =
  createContext<PermissionState>(defaultState);

export function usePermissionState(): PermissionState {
  return useContext(PermissionStateContext);
}
